import React, {ReactElement, useState, useContext, useEffect} from 'react';
import {ReactComponent as SignInIllustration} from '../../assets/images/sign-in-illustration.svg';
import {ReactComponent as Logo} from '../../assets/images/swiftpay-logo.svg';
import {TransHelper} from '../../utils/trans-helper';
import Box from '../shared/box/Box';
import MainContainer from '../shared/main-container/MainContainer';
import {BannerMessage, BannerType} from '../shared/main-container/MainContainer.model';
import LoginForm from './login-form/LoginForm';
import styles from './Login.module.scss';
import {SecurityContext} from '../../App';
import {useTranslation} from 'react-i18next';

export const PrefixTrans = TransHelper.getPrefixedTrans('LOGIN');

export default function Login(): ReactElement {

  const [error, setError] = useState<BannerMessage>();
  const {isLogged, logoutReason} = useContext(SecurityContext);
  const [sessionError, setSessionError] = useState<boolean>(false);
  const {t} = useTranslation();

  useEffect(() => {
    if (!isLogged && logoutReason == t('LOGIN.SESSION_EXPIRED_ERROR')) {
      setSessionError(true);
    } else {
      setSessionError(false);
    }
  }, [isLogged, logoutReason]);

  return (
    <MainContainer bannerMessage={error}>
      {
        sessionError && <div className={styles.errorBanner}>
          <PrefixTrans>SESSION_EXPIRED</PrefixTrans>
        </div>
      }
      <div className={styles.welcomeMessage}>
        <PrefixTrans>WELCOME_MESSAGE</PrefixTrans>
      </div>
      <div className={styles.boxRow}>
        <Box className={styles.loginForm}>
          <Logo className={styles.logo} title='SwiftPay' />
          <div className={styles.boxHeader}>
            <PrefixTrans>LOGIN_TO_YOUR_ACCOUNT</PrefixTrans>
          </div>
          <LoginForm onError={(message): void => setError({message, type: BannerType.ERROR})} />
        </Box>
        <Box className={styles.register}>
          <div className={styles.registerHeader}>
            <PrefixTrans>DONT_HAVE_ACCOUNT_YET</PrefixTrans>
          </div>
          <a target='_blank'
            rel='noreferrer'
            className={`${styles.registerLink}`}
            href={process.env.REACT_APP_REGISTER_URL}>
            <PrefixTrans>REGISTER_IN_3_MINS</PrefixTrans>
          </a>
          <SignInIllustration className={styles.registerIllustration} />
        </Box>
      </div>
    </MainContainer>
  );
}
